// Backend keys preserve exact Decimal values, including equivalent unit spellings.
export function characteristicOptions(field) {
 const keyOf=v=>v.choice_key||`raw:${v.raw?.trim()}`;
 const groups=new Map();
 const add=(v,source,label)=>{
  if(!v.raw)return;
  const key=keyOf(v),raw=v.raw.trim();
  if(!groups.has(key))groups.set(key,{sources:new Map(),variants:new Map()});
  const group=groups.get(key);
  group.sources.set(source,label||source);
  if(!group.variants.has(raw))group.variants.set(raw,new Set());
  group.variants.get(raw).add(source);
 };
 for(const e of field.evidence||[])add(e,['transfer','peer'].includes(e.source_kind)?`card:${e.source_ref}`:'own',e.source_label||e.evidence||'Источник карточки');
 for(const v of field.values||[])if(!(field.evidence||[]).some(e=>keyOf(e)===keyOf(v)))add(v,'own','Данные карточки');
 return [...groups.values()].map(v=>({raw:[...v.variants.keys()].sort((a,b)=>v.variants.get(b).size-v.variants.get(a).size||a.localeCompare(b,'ru'))[0],count:v.sources.size,sources:[...v.sources.values()]})).sort((a,b)=>b.count-a.count||a.raw.localeCompare(b.raw,'ru'));
}
